import { generateImageKitURL } from '@/lib/generate-imagekit-url'

export function HeroVideo({ textSlot, video, poster, multipleSlides = false }) {
  const { url: posterUrl } = poster || {}

  const borderClass = multipleSlides
    ? 'overflow-hidden ms-up:rounded-t-lg ms-up:border ms-up:border-b-0'
    : ''

  return (
    <div className={`grid h-full grid-cols-1 grid-rows-1 justify-between overflow-hidden`}>
      {/* Spacer/min-height */}
      <div className="pointer-events-none aspect-[1856/694] max-w-[1756px] ms:hidden ms-up:grid-area-fill [@media(max-height:780px)]:aspect-[1856/625]"></div>

      {/* Text slot */}
      <div className="pointer-events-none z-20 flex flex-col items-start py-xxl ms:pb-0 ms-up:self-center ms-up:grid-area-fill">
        <div className="container m-up:px-xl l-up:px-xxl">
          <div className="pointer-events-auto ms-up:max-w-[min(50%,680px)]">
            {textSlot ? textSlot : null}
          </div>
        </div>
      </div>

      {/* Video */}
      <div className={`hero-bg-video absolute inset-0 z-10 h-full w-full ${borderClass}`}>
        <video
          className="absolute inset-0 z-0 h-full w-full object-cover object-center"
          autoPlay
          loop
          muted
          playsInline
          poster={
            posterUrl
              ? generateImageKitURL(posterUrl, {
                  quality: '60',
                  width: '1280',
                  height: '1280',
                  crop: 'at_max',
                  focus: 'center',
                })
              : ''
          }
          preload="auto">
          <source src={video} type="video/mp4" />
        </video>
      </div>
    </div>
  )
}
